import moment from "moment";
import { BondOrderHistoryResponse } from "../components/Users/Orders/helpers";

export function getUpdatedAmountByStampDuty(settlementAmount: number) {
  if (settlementAmount >= 500000) {
    let upperLimit = 500000,
      lowerLimit = 0,
      cond = true,
      stampDuty = 0;
    if (0 <= settlementAmount && settlementAmount <= 499999) return 0;
    else {
      lowerLimit = 500000;
      upperLimit += 1000000;
      while (cond) {
        if (settlementAmount >= 100000000) {
          stampDuty = 100;
          cond = false;
        } else {
          if (
            lowerLimit <= settlementAmount &&
            settlementAmount <= upperLimit
          ) {
            stampDuty += 1;
            cond = false;
          } else {
            upperLimit += 1000000;
            lowerLimit += 1000000;
            stampDuty += 1;
          }
        }
      }
      return stampDuty;
    }
  } else return 0;
}

export const sortDate = (a: any, b: any) => {
  const [dayA, monthA, yearA] = a.date.split("/").map(Number);
  const [dayB, monthB, yearB] = b.date.split("/").map(Number);
  const dateA = new Date(yearA, monthA - 1, dayA);
  const dateB = new Date(yearB, monthB - 1, dayB);
  return dateA.getTime() - dateB.getTime();
};

export const parseDate = (raw?: string, additionalFormats: string[] = []) => {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const defaultFormats = [
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MM/DD/YYYY",
    "MMM DD,YYYY",
    "MMM DD, YYYY",
    "DD MMM YYYY",
  ];

  const formats = [...additionalFormats, ...defaultFormats];

  let parsed = moment(trimmed, formats, true);
  if (!parsed.isValid()) {
    parsed = moment(trimmed);
  }
  return parsed.isValid() ? parsed : null;
};

const getTimestamp = (value?: string) => {
  const timestamp = value ? new Date(value).getTime() : 0;
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const getOrderTimestamp = (order: BondOrderHistoryResponse) => {
  const settlementMoment = parseDate(order.settlement_date);

  if (settlementMoment) {
    return settlementMoment.valueOf();
  }

  return getTimestamp(
    order.insertedAt || (order as { inserted_at?: string }).inserted_at
  );
};

export const toINR = (value: any, fraction: number) => {
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: fraction,
  });
  return formatter.format(value);
};

export function is_gsec_sdl_tBill(securityType: string) {
  return [
    "State Development Loans",
    "Government Securities",
    "T Bill",
    "Treasury Bill",
  ].includes(securityType);
}

export function handleSecurityName(securityName: string) {
  return {
    securityCoupon: `${securityName.split("%", 2)[0]}%`,
    securityName: securityName.substring(securityName.indexOf("%") + 1).trim(),
  };
}

export const downloadPDFFile = (
  data: string | Blob,
  filename: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      let blob: Blob;

      if (typeof data === "string") {
        const binaryData = Buffer.from(data, "base64");
        blob = new Blob([new Uint8Array(binaryData)], {
          type: "application/pdf",
        });
      } else {
        blob = data;
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export let replaceCharsForSecurityName: { [key: string]: string } = {
  "%": "",
  " ": "-",
};
